export default {
  async addSite(context, payload) {
    const newRequest = {
      containerName: payload.containerName,
      containerTypeId: payload.containerTypeId,
      deviceSerial: payload.deviceSerial,
      operatorId: payload.operatorId,
      areaId: payload.areaId,
      siteNewProps: payload.properties,
      siteNewDevices: payload.devices,
    };

    console.log("ADDSITE", payload, newRequest);
    // /* eslint--disable */
    // return;
    var token = context.rootGetters["auth/getToken"];
    var bearer_token = "Bearer " + token;
    var apiUrl = context.rootGetters["config/getApiUrl"];
    var url = `${apiUrl}/sites/add`;

    // console.log("NEW SITE" , newRequest);
    const response = await fetch(url, {
      method: "POST",
      headers: {
        Authorization: bearer_token,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(newRequest),
    });

    if (!response.ok) {
      //const error = new Error(responseData.message || 'Failed to send request.');
      const error = new Error("Failed to send request.");
      throw error;
    }

    const responseJson = await response.json();
    const responseData = {
      recordsAffected: responseJson.recordsAffected,
      message: responseJson.message,
    };
    console.log("NEW SITE KEY", responseData.recordsAffected);
    context.commit("addSite", responseData);
  },
  async addSiteOtodata(context, payload) {
    const newRequest = {
      containerName: payload.containerName,
      deviceSerial: payload.deviceSerial,
      operatorName: payload.operatorName,
      areaName: payload.areaName,
    };

    var token = context.rootGetters["auth/getToken"];
    var bearer_token = "Bearer " + token;
    var apiUrl = context.rootGetters["config/getApiUrl"];
    var url = `${apiUrl}/sites/addotodata`;

    // console.log("NEW SITE" , newRequest);
    const response = await fetch(url, {
      method: "POST",
      headers: {
        Authorization: bearer_token,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(newRequest),
    });

    if (!response.ok) {
      //const error = new Error(responseData.message || 'Failed to send request.');
      const error = new Error("Failed to send request.");
      throw error;
    }

    const responseJson = await response.json();
    const responseData = {
      recordsAffected: responseJson.recordsAffected,
      message: responseJson.message,
    };
    context.commit("addSite", responseData);
  },

  async decommissionSite(context, payload) {
    const newRequest = {
      containerName: payload.containerName,
      deviceSerial: payload.deviceSerial,
    };

    var token = context.rootGetters["auth/getToken"];
    var bearer_token = "Bearer " + token;
    var apiUrl = context.rootGetters["config/getApiUrl"];
    var url = `${apiUrl}/sites/decommission`;

    const response = await fetch(url, {
      method: "POST",
      headers: {
        Authorization: bearer_token,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(newRequest),
    });

    if (!response.ok) {
      //const error = new Error(responseData.message || 'Failed to send request.');
      const error = new Error("Failed to send request.");
      throw error;
    }

    const responseJson = await response.json();
    const responseData = {
      recordsAffected: responseJson.recordsAffected,
      message: responseJson.message,
    };
    context.commit("decommissionSite", responseData);
  },

  // Swaps the device on a site: retires the current one and attaches a
  // replacement, optionally moving the site to a new operator/area at the same
  // time. When `decommission` is true the site is taken out of service instead
  // and no operator/area is sent.
  //
  // NOTE: the endpoint path and field names below are the assumed contract --
  // there was no device-swap endpoint in the codebase to copy. If the API
  // differs, this object and the URL are the only things that need changing.
  async switchDevice(context, payload) {
    const newRequest = {
      containerId: payload.containerId,
      containerName: payload.containerName,
      currentDeviceSerial: payload.currentDeviceSerial,
      newDeviceSerial: payload.newDeviceSerial,
      swapDate: payload.swapDate,
      decommission: payload.decommission === true,
    };

    // Only meaningful when the site stays in service.
    if (!newRequest.decommission) {
      newRequest.operatorId = payload.operatorId;
      newRequest.areaId = payload.areaId;
    }

    var token = context.rootGetters["auth/getToken"];
    var bearer_token = "Bearer " + token;
    var apiUrl = context.rootGetters["config/getApiUrl"];
    var url = `${apiUrl}/sites/deviceswap`;

    const response = await fetch(url, {
      method: "POST",
      headers: {
        Authorization: bearer_token,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(newRequest),
    });

    if (!response.ok) {
      const error = new Error("Failed to send request.");
      throw error;
    }

    const responseJson = await response.json();
    const responseData = {
      recordsAffected: responseJson.recordsAffected,
      message: responseJson.message,
    };
    context.commit("switchDevice", responseData);
    return responseData;
  },

  async bulkImportSites(context, payload) {
    var token = context.rootGetters["auth/getToken"];
    var bearer_token = "Bearer " + token;
    var apiUrl = context.rootGetters["config/getApiUrl"];
    var url = `${apiUrl}/sites/bulkimport`;

    const response = await fetch(url, {
      method: "POST",
      headers: {
        Authorization: bearer_token,
      },
      body: payload,
    });

    if (!response.ok) {
      const error = new Error("Failed to process bulk import.");
      throw error;
    }

    const responseJson = await response.json();
    const responseData = {
      success: responseJson.success || false,
      recordsProcessed: responseJson.recordsProcessed || 0,
      recordsCreated: responseJson.recordsCreated || 0,
      recordsUpdated: responseJson.recordsUpdated || 0,
      errors: responseJson.errors || [],
      rowErrors: responseJson.rowErrors || [],
      allRows: responseJson.allRows || [],
      message: responseJson.message || "",
      errorFileBytes: responseJson.errorFileBytes || 0,
      errorFileName: responseJson.errorFileName || "",
    };

    context.commit("setBulkImportResults", responseData);
  },
};
